import React from 'react'
import useIsMobile from '../hooks/useIsMobile'

const Contact = ({lang, translations}) => {
  const isDeviceMobile = useIsMobile();

  return (
    <main id={'contact'} className='flex background-black2'>
      <div className='black-bg2 flex-column around'>
      <div className='flex h2-title padding-bottom-5'>
          <h2>{translations[lang].contacttitle}</h2>
        </div>
        <div className="flex-column margin-negative ">
       
        <a href="https://maps.app.goo.gl/9v1kfrKwZgnugfot7" rel="nofollow noreferrer" target="_blank" className="no-link">
          <div className='flex'>
            {/* <img className="icono-ubicacion" src="img/ubicacion.png" alt={translations[lang].ubiicon}/> */}
            <p className="contact-text">📍&nbsp;Calle del Bisbe Urquinaona, 24,<br />08860 Castelldefels, Barcelona.</p>
            </div>
        </a>
        <br></br>
        <a href="tel:+34660371868" className="no-link">
          <div className='flex'>
          {/* <img className="icono-telefono" src="img/telefono.png" alt={translations[lang].telicon}/> */}
          <p className="contact-text">📞&nbsp;(+34) 660 371 868</p>
          </div>
        </a>
        <br></br>
        <a href="mailto:contacto@farocastelldefels.com" className="no-link">
          <div className='flex'>
            {/* <img className="icono-mail" src="img/correo.png" alt={translations[lang].mailicon}/> */}
            <p className="contact-text">📩&nbsp;contacto@farocastelldefels.com</p>
          </div>
        </a>
        
      </div>
      <div className="flex-column padding-bottom-5">
            <h4 className='contact-text'>{translations[lang].scheduletitle}</h4>

            <div className="flex-column">
              <p className='contact-text'>{translations[lang].schedule1}</p>
              <p className="contact-text">{translations[lang].schedule2}</p>
            </div> 
          </div>
       <a href="tel:+34660371868" className='no-link'>
         <div className="flex button1 margin-top-negative2">
              <p>{translations[lang].reservationbutton}</p>  
          </div>
          </a>
           
          <img src='img/img-bottom-contacto-y-reserva-blue.png' alt={translations[lang].tapasbackgroundalt} className={isDeviceMobile ? 'height30':'width100'}/>
        </div>
      
  </main>
  )
}

export default Contact